import { memo } from 'react'
import { NumericFormat } from 'react-number-format'
import moment from 'moment'

interface Props {
  readonly title: string
  readonly value?: number
  readonly description?: string
  readonly prefix?: string
  readonly suffix?: string
  readonly extraInfo?: string
}

const Component = (props: Props) => {
  const { title, value, description, prefix, extraInfo } = props

  return (
    <div className="stat width-100">
      <div className="stat-title">{title}</div>
      <div className="stat-value">
        <NumericFormat
          valueIsNumericString
          displayType="text"
          contentEditable={false}
          value={value}
          decimalScale={2}
          className="text-right flex justify-end"
          thousandSeparator={' '}
        />
        <div className="opacity-50 text-sm text-right">{prefix}</div>
        <div className="opacity-50 text-xs text-right font-light">{extraInfo}</div>
      </div>
      <div className="stat-desc">{description}</div>
    </div>
  )
}

export const StatsItem = memo(Component)